module.exports = __webpack_public_path__ + "img/icon-csv.1a3cd5ea.svg";